export default class Map {
    
    constructor() {

        this.settings = {
            $map: $("#map-canvas")
        };

        this.bindUIActions();
    }

    bindUIActions() {
        if (this.settings.$map.length) {

            let geocoder, map, marker, infoWindow;

            function initialize() {

                geocoder = new google.maps.Geocoder();

                const lightGrey = '#F5F5F5';
                const darkGrey = '#575756';
                const black = '#040404';
                const white = '#FFFFFF';

                const mapStyles = [
                    {
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": lightGrey,
                        }
                      ]
                    },
                    {
                      "elementType": "labels.icon",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": darkGrey,
                        }
                      ]
                    },
                    {
                      "elementType": "labels.text.stroke",
                      "stylers": [
                        {
                          "color": lightGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "administrative.land_parcel",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": black,
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": lightGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": darkGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "poi.business",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": lightGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "labels.text",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": darkGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "road",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": white,
                        }
                      ]
                    },
                    {
                      "featureType": "road.arterial",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": darkGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": darkGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": darkGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": darkGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "transit.line",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": lightGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "transit.station",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": lightGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": darkGrey,
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": darkGrey,
                        }
                      ]
                    }
                ]

                const mapOptions = {
                    zoom: 16,
                    styles: mapStyles,
                };

                map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
            
                const hiddenAddress = document.getElementById('hidden-address').textContent;
                
                geocodeIt(hiddenAddress);
            }

            function geocodeIt(address) {

                geocoder.geocode({ 'address': address }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {

                        map.setCenter(results[0].geometry.location);

                        marker = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location,
                            animation: google.maps.Animation.DROP,
                            opacity: 1.0,
                        });

                        infoWindow = new google.maps.InfoWindow({
                          content: '<div><strong>' + results[0].formatted_address + '</strong><br>' +
                                   '<a href="https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(results[0].formatted_address) + '" target="_blank" style="display:block; margin-top:8px; font-weight: 700;">Get Directions</a></div>',
                        });

                        marker.addListener('click', function () {
                            infoWindow.open(map, marker);
                        });

                    } else {

                        alert('Geocode was not successful for the following reason: ' + status);

                    }
                });
                
            }

            initialize();
        }
    }
}

new Map();